const compare = (a, b) => {
  if (a.key < b.key) return -1;
  if (a.key > b.key) return 1;
  return 0;
};

export default compare;



// WEBPACK FOOTER //
// ./src/pages/util/compare.js